<script>
export default {
  name: 'CarbonAds',
  watch: {
    $route(to, from) {
      if (
        to.path !== from.path &&
        // Only reload if the ad has been loaded
        // otherwise it's possible that the script is appended but
        // the ads are not loaded yet. This would result in duplicated ads.
        this.$el.querySelector('#carbonads')
      ) {
        this.$el.innerHTML = ''
        this.load()
      }
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      const s = document.createElement('script')
      s.id = '_carbonads_js'
      s.src = `//cdn.carbonads.com/carbon.js?serve=CE7IT27E&placement=frontendsourcecom`
      this.$el.appendChild(s)
    }
  },
  render(h) {
    return h('div', { class: 'carbon-ads' })
  }
}
</script>

<style lang="scss">
.carbon-ads {
  max-width: 800px;
  margin: 0 auto;
}

#carbonads {
  display: block;
  overflow: hidden;
  padding: 1em;
  border: solid 1px hsl(200, 37%, 85%);
  border-radius: 0.2rem;
  background-color: #e3edf2;
  font-size: 13px;
  line-height: 1.5;
}

#carbonads a {
  color: #40444f;
}

#carbonads a:hover {
  text-decoration: none;
}

#carbonads span {
  position: relative;
  display: block;
  overflow: hidden;
}

.carbon-img {
  float: left;
  margin-right: 1em;
}

.carbon-img img {
  display: block;
}

.carbon-text {
  display: block;
  float: left;
  max-width: calc(100% - 130px - 1em);
  text-align: left;
}

.carbon-poweredby {
  position: absolute;
  bottom: 0;
  left: 143px;
  display: block;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 9px;
  line-height: 1;
}
</style>
